export const COMMENTING_FEEDBACK = 'MO:CollaborationSidebar:CommentingFeedback';
export const UNREAD_COMMENTS = 'MO:CollaborationSidebar:UnreadComments';
export const FLOATING_SIDEBAR_ALL = 'MO:CollaborationSidebar:FloatingSidebar:All';
export const LIVE_COMMENTS = 'MO:CollaborationSidebar:LiveComments';
export const GET_LINK_TO_COMMENT = 'MO:CollaborationSidebar:GetLinkToComment';
export const MORE_UNREAD = 'MO:CollaborationSidebar:MoreUnread';
export const NOTIFICATION_SETTINGS = 'MO:CollaborationSidebar:NotificationSettings';
export const DISABLE_AT_MENTION = 'MO:CollaborationSidebar:DisableAtMention';